<template>
    <InstagramBusinessContentCard :page="page" :content="content" class="ContentCard" height="100%" />
</template>

<style lang="less" type="text/less"></style>

<script type="text/babel">
import InstagramBusinessContentCard from 'dashboard-js/components/influencers/InstagramBusinessContentCard'

export default {
    components: { InstagramBusinessContentCard },

    directives: {},

    mixins: [],

    props: ['content'],

    data() {
        return {
            page: null,
        }
    },

    computed: {},

    created() {        
        if (this.hasAncestorComponent('InfluencerJobShowPage') || this.hasAncestorComponent('BrandJobShowPage')) {
            this.page = true;
        }
    },

    methods: {
        hasParentComponent(name = 'InfluencerJobShowPage') {
            return this.$parent && this.$parent.$options.name === name;
        },

        hasAncestorComponent(name = 'InfluencerJobShowPage') {
            let parent = this.$parent;
            
            while (parent) {
            if (parent.$options.name === name) {
                return true;
            }
            parent = parent.$parent;
            }
            
            return false;
        }
    },
}
</script>
